import { Request } from 'src/helpers';
import { external_apis } from 'src/lib/endpoints';

const ITEMS_PER_REQUEST = 10000;

/**
 * @typedef {object} sentryLog
 * @property {string} personnelid Biometric id registered to employee
 * @property {string} personnelfirstname First name of employee
 * @property {string} personnellastname Last name of employee
 * @property {string} logdate Date in YYYY-MM-DD format
 * @property {string} logtime Time in HH:mm format
 * @property {'IN'|'OUT'} inout
 */

/**
 * @param {Request} request
 */
async function getBioApiToken(request) {
  return await request.get(external_apis.sentry.getToken);
}

/**
 * @param {Request} request
 * @param {string} token
 * @param {string} StartDate
 * @param {string} EndDate
 * @param {number} start
 * @param {sentryLog[]} logs
 */
async function getBioApiLogs(
  request,
  token,
  StartDate,
  EndDate,
  start = 0,
  logs = []
) {
  const res = await request.post(external_apis.sentry.getLogs, {
    data: {
      PersonnelNo: '',
      StartDate,
      EndDate,
      start,
      max: ITEMS_PER_REQUEST
    },
    BearerToken: token
  });

  if (!res.success)
    return {
      success: false,
      message: 'Failed to sync logs. Please contact your system administrator.',
      data: []
    };

  return res.data.length >= ITEMS_PER_REQUEST
    ? getBioApiLogs(
        request,
        token,
        StartDate,
        EndDate,
        start + ITEMS_PER_REQUEST,
        [...logs, ...res.data]
      )
    : {
        success: true,
        message: 'Successfully synced logs.',
        data: [...logs, ...res.data]
      };
}

/**
 * @param {Request} request
 * @param {{dt1: '', dt2: ''}} range
 * @returns {Promise<{success: boolean, message: string, data: Array<sentryLog>}>}
 */
async function getSentryLogs(request, range) {
  const token = await getBioApiToken(request);

  if (!token.success) {
    return {
      success: false,
      message: 'Failed to sync logs. Please contact your system administrator.',
      data: []
    };
  }

  return await getBioApiLogs(request, token.data, range.dt1, range.dt2);
}

export default getSentryLogs;
